export default __webpack_public_path__ + "static/media/1620935127675_image2.a8d111c7.jpeg";